export default "__VITE_ASSET__BjVhXS0b__"